<template>
  <div id="app">
    <Header></Header>
    <keep-alive>
      <router-view />
    </keep-alive>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue